import BaseFactory from 'services/sports/default/base-factory';
import LpClassic from './lp-classic';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new LpClassic(params);
    }
}

export {Factory};
